import { createLoadableList } from 'external/immutability-helper'
import create, {initializeAndRegisterHooks} from 'context/create' 
import triggers, * as resolves from './triggers'
import { AdminState } from 'types/context/admin'
import { emptyOffer } from 'types/offer'

const id = 'Admin'

export const initialState: AdminState = {
    currentOffer: emptyOffer,
    subjects: [],
    grades: [],
    offers: createLoadableList(),
    clients: createLoadableList(),
    courses: createLoadableList(),
    courseMap: false,
    clientsPaging: false,
    packages: [],
    client: {
        loading: false,
        id: false,
        purchases: createLoadableList(), 
        profile: false
    },
    changeCourseModal: {
        open: false,
        originalCourse: undefined,
        purchaseIndex: -1,
        source: '',
        selected: {
            subject: '',
            grade: '',
            course: ''
        }
    },
}

const context = create(id, initialState, {onInit: initializeAndRegisterHooks(id, triggers, resolves)})
export {context as default}